import { axiosBase, errorHandler } from "./axios";


// Phone-based OTP: send login code
const otpLogin = (input: any) => {
  return axiosBase.post("auth/login", input, {
    headers: { Authorization: `Bearer ${process.env.DEFAULT_TOKEN}` }
  }).then((response) => response.data).catch((error) => errorHandler(error));
};

const otpVerify = (input: any) => {
   return axiosBase.post("auth/login", input, {
    headers: { Authorization: `Bearer ${process.env.DEFAULT_TOKEN}` }
  }).then((response) => response.data).catch((error) => errorHandler(error));
};

// Resend OTP
const resendOtp = (input: any) => {
  return axiosBase.post("auth/resendOtp", input, {
    headers: { Authorization: `Bearer ${process.env.DEFAULT_TOKEN}` }
  }).then((response) => response.data).catch((error) => errorHandler(error));
};

const acceptInvitation = (data: any) => {
  return axiosBase.post("users/accept", data).
  then((response) => response.data).
   catch((error) => errorHandler(error));
}

const renewtoken = (input: any) => {
  return axiosBase.post("auth/renewToken", input, {
    headers: { Authorization: `Bearer ${process.env.DEFAULT_TOKEN}` }
  }).then((response) => response.data).catch((error) => errorHandler(error));
};

const verifyToken = (input: any) => {
  return axiosBase.post("auth/verifyToken", input, {
    headers: { Authorization: `Bearer ${process.env.DEFAULT_TOKEN}` }
  }).then((response) => response.data).catch((error) => errorHandler(error));
}

const registerTenant = (input: any) => {
  return axiosBase.post("auth/register", input, {
    headers: { Authorization: `Bearer ${process.env.DEFAULT_TOKEN}` }
  }).then((response) => response.data).catch((error) => errorHandler(error));
};

const verifyRegistration = (input: any) => {
  return axiosBase.post("auth/verifyRegistration", input, {
    headers: { Authorization: `Bearer ${process.env.DEFAULT_TOKEN}` }
  }).then((response) => response.data).catch((error) => errorHandler(error));
};

const checkTenantExists = (input: any) => {
  return axiosBase.get("auth/checkTenantExists", {
    params: input,
    headers: { Authorization: `Bearer ${process.env.DEFAULT_TOKEN}` }
  }).then((response) => response.data).catch((error) => errorHandler(error));
};


export const authService = {
    otpLogin,
    resendOtp,
    verifyToken,
    otpVerify,
    acceptInvitation,
    renewtoken,
    registerTenant,
    verifyRegistration,
    checkTenantExists,
}